import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  class: "chevron-down-up_svg__svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M5.414 1 12 7.586 18.586 1 20 2.414l-8 8-8-8L5.414 1ZM5.414 23.004 12 16.418l6.586 6.586L20 21.59l-8-8-8 8 1.414 1.414Z"
    }, null, -1)
  ]))]))
}
export default { render: render }